import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import supabase from 'modules/core/supabase/supabase';
import { GeneralInformation } from 'modules/overlay-v2/domain/interfaces/general-information';
import { getData } from 'modules/overlay-v2/domain/utils/get-data';

const PREFIX = 'gameInfo';

export const resetGameInfo = createAction(`${PREFIX}/resetGameInfo`);

export const syncGameInfo = createAsyncThunk<GeneralInformation, { matchId: number }>(
  `${PREFIX}/syncData`,
  async (payload, { rejectWithValue }) => {
    try {
      // Только данные. Прогрев лого и фото игроков вынесен в отдельный шаг чеклиста —
      // `preloadGameInfoAssets` из `store/readiness/actions.ts`: у него свой статус на
      // экране подготовки и свой бюджет времени.
      return await getData(payload.matchId);
    } catch (error) {
      console.error(`${PREFIX}/fetchUser error:`, error);

      let message;
      if ('message' in (error as Error)) message = (error as Error)?.message;
      else message = String(error);

      supabase.overlayLogs.createError({ comment: 'Не удалось получить данные при синхронизации', message });

      return rejectWithValue(message);
    }
  },
);
